import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Icon from 'shared/components/Icon';

const NavLink = ({ id, to, label, icon }) => (
  <li className="btn">
    <Link to={to} id={id}>
      <Icon name={icon} />
      <span className="text">{label}</span>
    </Link>
  </li>
);

NavLink.displayName = 'NavLink';

NavLink.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
};

export default NavLink;
